import { LOADING_LABELS } from '../constants/loading'
import { NOTIFICATIONS, type NotificationListProps } from '../constants/notifications'
import { cx, formatRelativeTime } from '../helpers/format'
import { Spinner } from './Spinner'
import '../styles/notifications.scss'

export function NotificationList({
  items,
  loading,
  error,
  onOpen,
}: NotificationListProps) {
  if (error) return <p className="notif-list__empty">{error}</p>
  if (loading) return <Spinner block label={LOADING_LABELS.page} />
  if (items.length === 0) return <p className="notif-list__empty">{NOTIFICATIONS.empty}</p>

  return (
    <ul className="notif-list">
      {items.map((item) => (
        <li key={item.id}>
          <button
            type="button"
            className={cx('notif-item', !item.readAt && 'notif-item--unread')}
            onClick={() => onOpen(item)}
          >
            <span className="notif-item__title">{item.title}</span>
            <span className="notif-item__body">{item.body}</span>
            <span className="notif-item__time">{formatRelativeTime(item.createdAt)}</span>
          </button>
        </li>
      ))}
    </ul>
  )
}
